module.exports = __webpack_public_path__ + "static/img/6dd114dd8be25e5968aee85811ed09b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ps_banner.jpg
// module id = J3jv
// module chunks = 1